<template>
  <div class="cashflow-type-fixed-expense card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="fixedExpenses.upToNowAmount"
                      :show-warning-if-exceeding-budget="false"/>

    <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                 :categories="fixedExpenses.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="false"
                                 :title="titles.categorySections.mainTitle"
                                 :expense-category="titles.cashflowType"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <predicted-transaction class="transaction-details"
                                     v-for="transaction in transactions"
                                     :can-edit-category="true"
                                     :predicted-transaction="transaction"
                                     :show-prediction="false"
                                     :category-name="CASHFLOW_TYPE"
                                     v-bind:key="transaction.transactionId">

          </predicted-transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import PredictedTransaction from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedTransaction.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';

export default {
  name: 'CashflowTypeFixedExpense',
  mixins: [CashflowAnalytics],
  components: {
    ExpenseProgress,
    PredictedTransaction,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.fixedExpense;
    },
    fixedExpenses() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'כמה יצא?',
        },
        categorySections: {
          actualsTitle: 'יצא',
          mainTitle: 'פירוט הוצאות קבועות',
        },
        cardTitle: 'הוצאות קבועות',
        cashflowType: 'קבועות',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .past-cashflow-view-container {
    .cashflow-type-fixed-expense {
      @include cashflow-card;

      .title {
        @include cashflow-card-title;
      }

      .details-container {
        margin-top: 8px;
      }

      .cashflow-type-color {
        color: $riseup_coral;
      }

      .cashflow-type-background-color {
        background-color: $riseup_coral;
      }
    }
  }
</style>
